<template>
  <div class="pd-10"
    :class="{ 'col-xs-12 col-sm-6 col-md-4': widgetTrackplusFlag, 'pd-tp-0': panel && panel.card_number != '2' && panel.card_number != '3' }">
    <div class="expiry_pending" :class="widgetTrackplusFlag ? 'widget' : ''">
      <div class="title summary_row d-flex">
        <span class="managedby_title">{{ $t('managedBy') }}</span>
      </div>
      <div class="product_details">{{ $t('productDetailsMessage') }}</div>
      <div class="ml--4">
        <report-status :key="render"></report-status>
      </div>
    </div>
    <div class="col-xs-12 footer p-0">
      <div class="col-xs-12 p-0 flex-between">
        <div style="float:left;" class="d-flex">
          <button class="btn btn-delete-address p-0 d-flex" @click="redirect()" v-if="permissions.indexOf('REG_TRACKER_RECORDS') > -1 && permissions.indexOf('ADD_A_RECORD') > -1 && roleId!==roleInfo['RA Admin'] && roleId!==roleInfo['RA Viewer']">
              <img src="/static/images/icons/add_circle.svg" class="save" />
            <span class="add-record">{{ $t('addRecord') }}</span></button>
        </div>
        <button type="button" class="btn view_all_button" @click="redirect()" >
           <span class="seeMore pr-8">{{ $t('viewAll') }}</span>
            <img src="/static/images/icons/Back.svg" class="pl-10 pb-3" />
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import ReportStatus from '../Reports/ReportStatus.vue';
import EventBus from '../../utils/event-bus';

export default {
  props: ['widgetTrackplusFlag', 'pending_summary', 'pendingVisible', 'openPopover', 'panel', 'permissions', 'roleId', 'roleInfo'],
  components: {
    ReportStatus,
  },
  data() {
    return {
      render: 0,
    };
  },
  methods: {
    redirect() {
      this.$router.push('/layout/registration');
    },
  },
  created() {
    EventBus.$on('updateLanguage', () => {
      this.render += 1;
    });
  },
};
</script>

<style scoped>
.ml--4{
  margin-left: -4px;
}
.add-record{
  font-weight: 400;
font-size: 14px;
line-height: 19px;
color: #01518A;
padding-left: 4px;
}
.btn-delete-address {
  background: none;
  padding-bottom: 4px;
  /* min-width: 90px; */
  /* box-shadow: 0px 0px 0px 2px rgba(199, 16, 16, 0.72) inset !important; */
  /* color: rgba(199, 16, 16, 0.72);
  border-radius: 30px; */
  /* border-width: 2px;
      border-color: rgba(199, 16, 16, 0.72); */
}

.view_all_button,
.view_all_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}

.pl-8{
  padding-left: 8px;
}
.add_record_button,
.add_record_button:hover {
  background-color: #01518A;
  border: 1px solid #01518A;
  height: 36px;
  min-width: 160px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  border-radius: 5px;
  line-height: 25px;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 25%);
}

.font-18 {
  font-size: 18px;
}

.el-button--success {
  background: #4c9e45;
  border: 1px solid #4c9e45;
  font-weight: 500;
  border-radius: 30px;
  padding: 5px 20px 5px 20px;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.footer {
  padding-right: 8px;
  padding-left: 21px;
  position: absolute;
  bottom: 8px;
  right: 0px;
}

.seeMore {
  /* font-size: 18px; */
  color: #FFFFFF;
  /* float: right;
  cursor: pointer;
  font-weight: 700;
  line-height: 25px; */
}

.d-flex {
  display: flex;
}

.jc-end {
  justify-content: flex-end;
}

.mb--10 {
  margin-bottom: -10px;
}

.mt-10 {
  margin-top: 10px;
}

/* .summary_row {
  border-bottom: 0.7px solid #BDBDBD;
  padding-bottom: 13px;
} */

/* .widget {
  min-height: 376px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 10px 24px 24px 24px;
  background: #ffffff;
} */
.dashboard-trackplus-cards .title {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}

.title {
  /* border-bottom: 0.5px solid #B4B4B4; */
  padding-bottom: 33px;
  padding-left:3px
  /* margin-bottom: 16px; */
}

.managedby_title {
  padding-left: 1px;
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #3E3E3E;
}

.dashboard-trackplus-cards .track_plus_icon_blue {
  width: 32px;
  height: 32px;
}

.dashboard-trackplus-cards .MT-12 {
  margin-top: 12px;
}

.dashboard-trackplus-cards .pd-10 {
  padding: 10px;
}

.dashboard-trackplus-cards .pd-tp-0 {
  padding-top: 0px !important;
}

.dashboard-trackplus-cards .expiry_pending .tab_expiry {
  line-height: 13px;
}

.dashboard-trackplus-cards .expiry_pending h3 {
  line-height: 33px;
}

.MT-25 {
  margin-top: 25px;
}

.expiry_pending h3 {
  margin-top: 0px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}

.expiry_pending .tab_expiry {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 12px;
  margin-bottom: 6px;
}

.expiry_pending .progress_count {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  float: right;
}

.expiry_pending .green {
  background: #4C9E45;
}

.expiry_pending .orange {
  background: #F2994A;
}

.expiry_pending .blue {
  background: #2F80ED;
}

.expiry_pending .red {
  background: #CF5F28;
}

.expiry_pending .progress {
  height: 11px;
  margin-bottom: 0;
  background: #C4C4C4;
  box-shadow: none;
  border-radius: 8px;
}

.cursor_pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}

.product_details {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #333333;
  padding-left: 3px;
}

@media screen and (max-width: 991px) {
  .content-wrappper .widget {
    margin-top: 20px !important;
  }
}
</style>
